import { useState, useEffect } from 'react';
import { SalonServiceResponse } from '@/api/generated/api';
import { salonsApi } from '@/api/api';

interface UseSalonServicesReturn {
  services: SalonServiceResponse[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useSalonServices = (salonId: string, activeOnly: boolean = true): UseSalonServicesReturn => {
  const [services, setServices] = useState<SalonServiceResponse[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchServices = async () => {
    if (!salonId) {
      setError('Není vybrán salon');
      return;
    }

    setIsLoading(true);
    setError(null);
    
    try {
      const response = await salonsApi.getSalonServices({ 
        id: salonId,
        active: activeOnly,
        limit: 100 // Získáme všechny služby
      });
      
      setServices(response.data.data);
    } catch (err) {
      console.error('Chyba při načítání služeb salonu:', err);
      setError(err instanceof Error ? err.message : 'Nepodařilo se načíst služby salonu');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (salonId) {
      fetchServices();
    }
  }, [salonId, activeOnly]);

  return {
    services,
    isLoading,
    error,
    refetch: fetchServices,
  };
};
